<template>
    <div class="page-talents-introduce">
        <div class="introduce-top-wrap">
          <div class="introduce-main-box">
            <div class="top-tit">
              <h2>海量、新鲜、精准</h2>
              <p class="txt1">精准匹配新鲜简历，智能邀约意向人才</p>
              <p class="txt1">告别人肉搜索、意向询问，节省HR90%的工作时间</p>
              <p class="txt2">适用于<strong>普通职位</strong></p>
              <a href="javascript://" @click="unloginBuyServicePop = true">点击购买</a>
              <a href="https://onwork.hunteron.com/" target="_blank">申请试用</a>
            </div>
	          <div class="top-mac"></div>
          </div>

        </div>

        <div class="introduce-challenge">
          <div class="introduce-main-box">
            <p class="en">DISCOVER TALENT</p>
            <p class="p1">解决HR日常招聘面临的挑战</p>
          </div>
        </div>

        <div class="introduce-contrast">
          <div class=" introduce-main-box">
            <p class="en">EFFICIENCY COMPARISON</p>
            <p class="p1">猎上成功入职1人成本及效率对比</p>
          </div>
        </div>
        <div class="introduce-buy">
          <p class="p1">申请购买可以点击下方链接</p>
          <p class="p2">客户经理会第一时间与您取得联系</p>
          <a href="javascript://" @click="unloginBuyServicePop = true">购买智能简历库</a>
          <a href="https://onwork.hunteron.com/" target="_blank">申请试用</a>
        </div>
        <unlogin-buy-service-success :service-user="serviceUser" v-if="unloginBuyServiceSuccessPop" v-model="unloginBuyServiceSuccessPop"></unlogin-buy-service-success>
        <unlogin-buy-service tit="购买发现人才" desc="buy-talents" code="intentionInvite" v-if="unloginBuyServicePop" @openServiceSuccess="openServiceSuccess" v-model="unloginBuyServicePop"></unlogin-buy-service>
    </div>
</template>
<script>
import unloginBuyService from "@/components/unloginBuyService";
import unloginBuyServiceSuccess from "@/components/unloginBuyServiceSuccess";
import DB from "@/common/db";
export default {
  name: "talents-introduce",
  data() {
    return {
      unloginBuyServicePop: false,
      unloginBuyServiceSuccessPop: false,
      serviceUser: {}
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      DB.request({
        url: DB.prefix + "auth/v2/link",
        type: "get",
        success: res => {
          if (res.data && res.data.isLogin) {
            window.location.href = "/talents.html#/";
          }
        },
        complete: () => {}
      });
    });
  },
  methods: {
    openServiceSuccess(serviceUser) {
      this.serviceUser = serviceUser;
      this.unloginBuyServiceSuccessPop = true;
    }
  },
  components: {
    unloginBuyService,
    unloginBuyServiceSuccess
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.page-talents-introduce {
  width: 100%;
  background: #fff url("../../assets/introduce/bg.jpg") no-repeat 0 -330px;
  background-size: 100%;
  height: 500px;
  .introduce-main-box {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }
  .introduce-top-wrap {
    height: 500px;
    background: #2d8cf0;
    background: rgba(45, 140, 240, 0.8);
    background-size: 100%;
    filter: Alpha(opacity=.8);
    *zoom: 1;
    color: #fff;
    .top-tit {
      padding-top: 156px;
      color: #fff;
      width: 100%;
      h2 {
        font-size: 48px;
        line-height: 68px;
      }
      p {
        font-size: 24px;
        line-height: 40px;
      }
      .txt2 {
        font-size: 16px;
        strong {
          margin-left: 5px;
        }
      }
      a {
        border-radius: 42px;
        font-size: 18px;
        line-height: 45px;
        display: inline-block;
        height: 45px;
        color: #2d8cf0;
        width: 188px;
        margin-top: 50px;
        background: #fff;
        text-align: center;
        margin-right: 20px;
      }
    }
    .top-mac {
      position: absolute;
      width: 690px;
      height: 468px;
      background: url("../../assets/introduce/mac1.png") no-repeat left 0;
      background-size: 100%;
      right: 0;
      top: 170px;
    }
  }
  .introduce-challenge {
    padding-top: 150px;
    height: 700px;
    background: url("../../assets/introduce/roadmap-bg.jpg");
    background-size: contain;
    p {
      display: none;
    }
    .introduce-main-box {
      background: url("../../assets/introduce/img1.png") no-repeat center;
      height: 450px;
    }
  }
  .introduce-contrast {
    background-color: #fff;
    padding: 55px 0 100px;
    p {
      display: none;
    }
    .introduce-main-box {
      background: url("../../assets/introduce/img2.png") no-repeat center;
      height: 621px;
    }
  }

  .introduce-buy {
    width: 100%;
    height: 250px;
    background: #fff url("../../assets/introduce/footer.jpg") no-repeat center
      center;
    text-align: center;
    color: #fff;
    padding-top: 45px;
    .p1 {
      font-size: 36px;
      line-height: 50px;
    }
    .p2 {
      font-size: 20px;
      line-height: 28px;
      margin-top: 4px;
    }
    a {
      border-radius: 42px;
      font-size: 18px;
      line-height: 45px;
      display: inline-block;
      height: 45px;
      color: #2d8cf0;
      width: 188px;
      margin-top: 30px;
      margin-right: 20px;
      background: #fff;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/unloginIntroduce/talentIntroduce.vue